import { userActions } from "../../actionTypes";

const initialState = {
	userDetails: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case userActions.FACEBOOK_USER_DETAILS_FETCHING: {
			return { ...state, fetching: true };
		}

		case userActions.FACEBOOK_USER_DETAILS_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				userDetails: action.payload,
			};
		}

		case userActions.FACEBOOK_USER_DETAILS_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
			return state;
	}
};

export default Reducer;
